import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { HorizontalForm, CustomButton, LabelContent } from '../../../../../common/components';
import { TYPE_LABELS } from '../../constants/taskTemplatesConstants';

/**
 * Componente de filtros para tareas (simplificado ya que están en contexto de plantilla)
 */
const TasksFilters = ({ onCreateNew, templateType }) => {
  return (
    <HorizontalForm withBorder={true} sx={{ paddingTop: 2, gap: 3, mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'stretch', sm: 'center' },
          justifyContent: 'space-between',
          width: '100%',
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <LabelContent
            label={'Tipo de Plantilla'}
            content={TYPE_LABELS[templateType]}
            sx={{ fontWeight: 'medium' }}
          />
        </Box>

        <CustomButton
          variant="base"
          onClick={onCreateNew}
          startIcon={<AddIcon />}
          sx={{ minWidth: '140px', width: { xs: '100%', sm: 'auto' } }}
        >
          Nueva Tarea
        </CustomButton>
      </Box>
    </HorizontalForm>
  );
};

export default TasksFilters;
